import reactComponentLoader from 'scripts/react-component-loader'

import HeaderDisclaimer from './index'

reactComponentLoader(HeaderDisclaimer, '[data-header-disclaimer]')
